import {useMutation, useQueryClient} from '@tanstack/react-query'
import updateEmployee from './api/updateEmployee'
import {Employee} from '../../core/entities/employee'
import deleteEmployeeQR from '../common/api/deleteEmployeeQR'

const useUpdateEmployee = (onSuccess: () => void) => {
    const qc = useQueryClient()
    const onMutationSuccess = (_: unknown, {qrId}: {qrId: number}) => {
        deleteEmployeeQR(qrId)
        onSuccess()
        qc.invalidateQueries(['employees', 'get'])
    }
    return useMutation(
        ['employees', 'update'],
        (employee: Employee) => updateEmployee(employee),
        {onSuccess: onMutationSuccess},
    )
}

export default useUpdateEmployee
